var _defs, _path, _path2, _path3, _path4, _ellipse, _path5, _ellipse2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSfccLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#41b658;}.cls-2,.cls-3{fill:#2e844a;}.cls-4{fill:#fff;}.cls-3{isolation:isolate;}.cls-5{fill:#1c3326;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.202,38.911c.244,1.194,1.397,1.973,2.603,1.784,5.758-.906,11.661-1.377,17.674-1.377,5.596,0,11.097.408,16.474,1.195,1.249.183,2.422-.669,2.603-1.916l3.42-23.539c.224-1.542-1.155-2.839-2.692-2.567-6.421,1.136-13.029,1.728-19.776,1.728-7.715,0-15.249-.775-22.528-2.251-1.61-.327-3.063,1.082-2.735,2.689l4.957,24.254Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.245,14.657c-.328-1.607,1.124-3.015,2.735-2.689.102.021.204.041.306.062l1.496,7.293c1.859,5.565,8.976,16.285,20.614,19.994-5.984.004-11.86.475-17.591,1.377-1.206.19-2.359-.59-2.603-1.784l-4.957-24.254Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.878,17.406c.59-.093,1.075.162,1.27.528.167.273.241.633.162,1.008-.374,1.777-.665,3.713-.847,5.746-.073.814-.949,1.288-1.513.696-.367-.385-.673-.826-.906-1.306-.487-.91-.763-1.527-1.79-2.118-.811-.468-2.171-.556-3.181-.614-1.735-.065-3.301-.481-4.499-1.155-.961-.541-.429-1.692.674-1.734,2.098-.081,4.323-.248,6.621-.509,1.373-.155,2.712-.337,4.008-.541Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.138,4c1.307,0,2.441.901,2.733,2.172l8.56,37.183c.312,1.354,1.614,2.336,3.124,2.236,3.193-.212,6.413-.32,9.659-.32,5.026,0,9.993.259,14.886.764v5.628c-4.889-.525-9.856-.795-14.886-.795-3.121,0-6.217.104-9.286.308-4.136.275-8.009-2.418-8.964-6.567L9.905,9.597s-1.816.134-4.037.889c-.884.3-1.867-.321-1.867-1.253v-3.548c0-.93.756-1.684,1.688-1.684h6.45Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 50.351,
    cy: 52.981,
    rx: 7.033,
    ry: 7.019
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.589,47.057c-.301.781-.466,1.63-.466,2.517,0,3.874,3.147,7.014,7.029,7.014,1.382,0,2.671-.398,3.758-1.086-1.014,2.631-3.57,4.497-6.563,4.497-3.882,0-7.029-3.14-7.029-7.014,0-2.495,1.305-4.685,3.271-5.928Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 19.404,
    cy: 52.981,
    rx: 7.033,
    ry: 7.019
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.641,47.057c-.301.781-.466,1.63-.466,2.517,0,3.874,3.147,7.014,7.029,7.014,1.382,0,2.671-.399,3.758-1.086-1.014,2.63-3.57,4.497-6.563,4.497-3.882,0-7.029-3.14-7.029-7.014,0-2.494,1.305-4.685,3.27-5.928Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfccLogo);
export default __webpack_public_path__ + "static/media/sfcc-logo.00c0e5559573db40229e6b4475f644f5.svg";
export { ForwardRef as ReactComponent };